import { FC } from 'react';
import { observer } from 'mobx-react';
import { ButtonToggle, Flex } from '@servicetitan/anvil2';
import { useDependencies } from '@servicetitan/react-ioc';

import { QuestionsStore } from '../../../question-picker/stores/questions.store';

const feedbackDetailsList = [
    'Did not answer my question',
    'Information was wrong',
    'Not enough information',
];

interface FeedbackDetailsProps {}

export const FeedbackDetails: FC<FeedbackDetailsProps> = observer(() => {
    const [questionsStore] = useDependencies(QuestionsStore);

    const handleProvideFeedback = (feedback: (typeof feedbackDetailsList)[0]) => {
        questionsStore.handleFeedbackNo(feedback);
    };

    return (
        <Flex wrap="wrap" gap="2">
            {feedbackDetailsList.map(d => {
                return (
                    <ButtonToggle
                        key={d}
                        className="m-b-1"
                        onClick={() => handleProvideFeedback(d)}
                    >
                        {d}
                    </ButtonToggle>
                );
            })}
        </Flex>
    );
});
